import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export function PasswordValidationErrorsList({ errors }) {
    return errors.length ? (
        <div>
            <ValidationTitle>Your password needs:</ValidationTitle>
            <ValidationErrorList data-testid="validation-errors">
                {errors.map(error => (
                    <ValidationError key={error}>{error}</ValidationError>
                ))}
            </ValidationErrorList>
        </div>
    ) : null;
}

const ValidationErrorList = styled.ul`
    padding-left: 1.3em;
    font-size: 0.9em;
    text-align: initial;
`;

const ValidationError = styled.li`
    color: red;
`;

const ValidationTitle = styled.label`
    color: red;
    font-size: 1.1em;
`;

PasswordValidationErrorsList.propTypes = {
    errors: PropTypes.array
};
